import React, { useEffect, useState, useMemo, useRef } from "react"
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap"
import {shareSchema, smsSchema} from "./forms/validation/schema"

import ShareModal from "./share"
import SmsModal from "./sms"

import { consoleCopy } from "store/actions"


const ActionModal = props => {
    
  const dispatch = useDispatch()

  const selectConsoleShare = state => state.console
  const ConsoleProperties = createSelector(selectConsoleShare, console => ({
    loading: console.loading,
    response: console.response,
    error: console.error,
  }))

  const { response, error, loading } = useSelector(selectConsoleShare)

  //const [shareable, setShareable] = useState(false)
  const [shareableModal, setShareableModal] = useState(false)
  const [smsModal, setSmsModal] = useState(false)

  const { isOpen, toggle, id, collection } = props
  let item = _.filter(collection, function (o) {
    return o.id == id
  })[0]

  const toggleShareableModal = () => {
    setShareableModal(!shareableModal)
  } 

  const toggleSmsModal = () => {
    setSmsModal(!smsModal)
  }

  

  return (
    <React.Fragment>
      <>
      {item ? (
        <>
      <ShareModal
        isOpen={shareableModal}
        toggleShareableModal={toggleShareableModal}
        toggle={toggle}
        item={item}
        schema={shareSchema({personalized_url : item.url, firstname : '', lastname : '', email : ''})}
        />  
        <SmsModal
          isOpen={smsModal}
          toggleSmsModal={toggleSmsModal}
          toggle={toggle}
          item={item}
          schema={smsSchema({personalized_url : item.url,cellphone : '', })}
          /> 
          </>
      ) : null} 
      <Modal
        isOpen={isOpen}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="company-modal"
        tabIndex="-1"
        toggle={toggle}
      >
        <div className="modal-content">
          <ModalHeader toggle={toggle}>
            {item && item.name }
          </ModalHeader>
          <ModalBody>
            <div className="table-responsive">
              <Table className="table align-middle table-nowrap">
                <tbody>
                  <tr>
                    <th scope="row">
                      <div className="d-grid gap-2">
                        <Link
                          onClick={() => {
                            try {
                              dispatch(consoleCopy(item, navigator))
                            } catch (error) {
                              console.error({ error })
                            }
                          }}
                          type="button"
                          color="secondary"
                          className="btn  btn-soft-secondary"
                        >
                          <i className="mdi mdi-content-copy mdi-18px"></i>{"  "}Copy Personalized Link
                        </Link>
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <th scope="row">
                      <div className="d-grid gap-2">
                        <Link
                          //to={`/merchants/vetting/edit/${id}`}
                          onClick={() => {
                            setShareableModal(true)
                          }}
                          type="button"
                          color="warning"
                          className="btn  btn-soft-warning"
                        >
                          <i className="mdi mdi-share-variant font-size-18"></i>{"  "}Share Personalized Link
                        </Link>
                      </div>
                    </th>
                  </tr>

                  <tr>
                    <th scope="row">
                      <div className="d-grid gap-2">
                        <Link
                          //to="#"                          
                          onClick={() => {
                            setSmsModal(true)
                          }}
                          type="button"
                          color="info"
                          className="btn  btn-soft-info"
                        >
                          <i className="mdi mdi-message-bulleted mdi-18px"></i>{"  "}Text Personalized Link
                        </Link>
                        {/* <Button
                          color="primary"
                          type="button"
                          className="btn-sm  btn-soft-danger"
                        >
                          <i className="mdi mdi-delete-empty mdi-18px"></i> Delete
                        </Button> */}
                      </div>
                    </th>
                  </tr>
                </tbody>
              </Table>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button type="button" color="light" onClick={toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </div>
      </Modal>
      </>
      </React.Fragment>
  )
}

ActionModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
}

export default ActionModal
